import { API_PREFIX } from '@/config/api'
import router from '@/router'
import { EVENT_CHECKPOINT_ROUTES } from '@/router/routes'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import { api } from '@rfc/rfc-components-library/helpers'
import type { FilterType, PaginationType } from '@rfc/rfc-components-library/types'
import { buildQueryUrl } from '@rfc/rfc-components-library/utils'

const API_EVENT_PREFIX = (eventId: number) =>
    `${API_PREFIX}${EVENT_CHECKPOINT_ROUTES.buildUrl(eventId)}`

const checkpointApi = {
    addCheckpointToEvent: (eventId: number, checkpointData: Partial<CheckpointModel>) =>
        api.post(`${API_EVENT_PREFIX(eventId)}`, checkpointData),
    deleteCheckpointFromEvent: (eventId: number, checkpointId: number) =>
        api.delete(`${API_EVENT_PREFIX(eventId)}/${checkpointId}`),
    updateCheckpointFromEvent: (
        eventId: number,
        checkpointId: number,
        checkpointData: Partial<CheckpointModel>
    ) => api.patch(`${API_EVENT_PREFIX(eventId)}/${checkpointId}`, checkpointData),

    getCheckpointsFromEvent: (
        eventId: number,
        params?: Partial<PaginationType> & Partial<FilterType<Partial<CheckpointModel>>>,
        noQueryParam?: boolean
    ) =>
        api
            .get(`${API_EVENT_PREFIX(eventId)}${buildQueryUrl(params, noQueryParam, router)}`)
            .then(res => res.data),
    getSpecificCheckpointFromEvent: (eventId: number, checkpointId: number) =>
        api.get(`${API_EVENT_PREFIX(eventId)}/${checkpointId}`),
    associateDeviceToCheckpoint: (
        eventId: number,
        checkpointId: number,
        device_id: number,
        config?: Record<string, number>,
        force?: boolean
    ) =>
        api
            .post(`${API_EVENT_PREFIX(eventId)}/${checkpointId}/associate`, {
                device_id,
                config,
                force
            })
            .catch(err => Promise.reject(err.data)),
    unassociateDeviceFromCheckpoint: (eventId: number, checkpointId: number, device_id: number) =>
        api.post(`${API_EVENT_PREFIX(eventId)}/${checkpointId}/unassociate`, { device_id }),

    eraseDetectionsFromCheckpoint: (eventId: number, checkpointId: number) =>
        api.delete(`${API_EVENT_PREFIX(eventId)}/${checkpointId}/detections`)
}

export default checkpointApi
